import { render, staticRenderFns } from "./TodoEditModal.vue?vue&type=template&id=a3d3959e&scoped=true"
import script from "./TodoEditModal.vue?vue&type=script&lang=js"
export * from "./TodoEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d3959e",
  null
  
)

export default component.exports